/*
 * Copyright (c) 2017 Payoneer Germany GmbH. All rights reserved.
 */

var presetAccountTemplate = require('../../templates').presetAccountTemplate;
var hiddenPresetAccountTemplate = require('../../templates').hiddenPresetAccountTemplate;
var translate = require('./translate.service');
var maskedAccountService = require('./masked-account.service');
var rootScope = require('./root-scope.service');

function createPresetAccountHtml(presetAccount, templateName) {
    presetAccount.networkCode = 'preset';
    presetAccount.grouping = 'groupingPreset';
    presetAccount.id = -1;
    presetAccount.tooltip = translate('accounts.delete.tooltip.label');
    presetAccount.isCardView = rootScope.isCardView() == 'true' ? true : false;

    // Normalize a display label: spaces to non-breakable spaces
    if (presetAccount.maskedAccount && presetAccount.maskedAccount.displayLabel) {
        presetAccount.maskedAccount.displayLabel = maskedAccountService.formatMaskedAccount(presetAccount);
    }
    if (presetAccount.maskedAccount && presetAccount.maskedAccount.expiryMonth && presetAccount.maskedAccount.expiryYear) {
        presetAccount.dateString = maskedAccountService.formatDateString(presetAccount);
    }

    presetAccount.expiredLabel = translate('accounts.expired.badge.label');
    presetAccount.isExpired = maskedAccountService.isExpired(presetAccount) ? true : false;

    return glob.summaryPage ? hiddenPresetAccountTemplate(presetAccount, templateName) : presetAccountTemplate(presetAccount, templateName);
}

/**
 * Return presetAccount.
 *
 * @param presetAccount {Object}
 * @param templateName {String}
 * @return snippet {String} snippet of HTML containing the presetAccount
 */
function getPresetAccount(presetAccount, templateName) {
    if (presetAccount === null) {
        return '';
    }

    return createPresetAccountHtml(presetAccount, templateName);
}

module.exports = getPresetAccount;
